export default {
  PROCESS_FINALIZED: 1,
  NO_RETURN: 2,
  RENEWED_WITH_ANOTHER_BROKER: 3,
  OTHERS: 4
}
